export default __webpack_public_path__ + "static/B0001-05685cd9e6a3fb43a91f7422855d4111.png";